import { z } from "zod"

export const PostUserSchema = z.object({
  id: z.number(),
  username: z.string(),
  name: z.string(),
  avatar: z.string().nullable(),
})

export const LikeUserSchema = z.object({
  user_id: z.number(),
  username: z.string(),
  name: z.string(),
  avatar: z.string().nullable(),
})

export const PostTagSchema = z.object({
  id: z.number(),
  name: z.string(),
})

type CommentType = {
  id: number
  report_to: number
  user: z.infer<typeof PostUserSchema>
  content: string
  level: number
  post_id: number
  childreens: CommentType[]
  date: string
  can_edit: boolean
  can_approve: boolean
  can_delete: boolean
  status: number
}

export const CommentSchema: z.ZodType<CommentType> = z.lazy(() =>
  z.object({
    id: z.number(),
    report_to: z.number(),
    user: PostUserSchema,
    content: z.string(),
    level: z.number(),
    post_id: z.coerce.number(),
    childreens: z.array(CommentSchema),
    date: z.string(),
    can_edit: z.boolean(),
    can_approve: z.boolean(),
    can_delete: z.boolean(),
    status: z.number(),
  })
)

export const PostSchema = z.object({
  id: z.number(),
  user: PostUserSchema,
  images: z.array(z.string()),
  content_type: z.number(),
  content: z.string(),
  content_pure: z.string().nullable(),
  status: z.number(),
  preview_img: z.string().nullable(),
  preview_title: z.string().nullable(),
  preview_url: z.string().nullable(),
  created_at: z.string(),
  can_edit: z.boolean(),
  can_moderate: z.boolean(),
  visible_to: z.number().nullable(),
  repost: z.boolean(),
  repost_post: z.unknown().nullable(),
  tags: z.array(PostTagSchema),
  link: z.string(),
  user_like: z.boolean(),
  likes: z.array(LikeUserSchema),
  comments: z.array(CommentSchema),
  comments_length: z.number(),
})

export const PostsResponseSchema = z.object({
  posts: z.array(PostSchema),
  max_posts: z.number(),
})

export const PostMessagesSchema = z.object({
  user_like: z.boolean(),
  likes: z.array(LikeUserSchema),
  comments: z.array(CommentSchema),
  comments_length: z.number(),
})

export const TagSchema = z.object({
  id: z.number(),
  name: z.string(),
})

export type PostUser = z.infer<typeof PostUserSchema>
export type PostTag = z.infer<typeof PostTagSchema>
export type Post = z.infer<typeof PostSchema>
export type PostsResponse = z.infer<typeof PostsResponseSchema>
export type LikeUser = z.infer<typeof LikeUserSchema>
export type Comment = z.infer<typeof CommentSchema>
export type PostMessages = z.infer<typeof PostMessagesSchema>
export type Tag = z.infer<typeof TagSchema>